import React, { createContext, useContext, useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  signInWithPopup, 
  GoogleAuthProvider, 
  signOut,
  onAuthStateChanged 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { toast } from 'react-toastify';

// Firebase configuration - replace with your own config
/*
const firebaseConfig = {
  apiKey: "YOUR_API_KEY",
  authDomain: "YOUR_AUTH_DOMAIN",
  projectId: "YOUR_PROJECT_ID",
  storageBucket: "YOUR_STORAGE_BUCKET",
  messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
  appId: "YOUR_APP_ID"
};
*/
const firebaseConfig = {
    apiKey: "AIzaSyDuDC78DwfVRcFVa06OzTQme3-yOzsq8_I",
    authDomain: "swe-simple-2.firebaseapp.com",
    projectId: "swe-simple-2",
    storageBucket: "swe-simple-2.firebasestorage.app",
    messagingSenderId: "765644978726",
    appId: "1:765644978726:web:f4fe3b1be6b0afeba544e7",
    measurementId: "G-LHZ06866SL"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();

// Admin user emails - replace with actual admin emails
const ADMIN_EMAILS = ['admin@example.com'];

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setIsAdmin(user ? ADMIN_EMAILS.includes(user.email) : false);
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      toast.success('Successfully logged in!');
      return result.user;
    } catch (error) {
      toast.error('Failed to log in: ' + error.message);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      toast.success('Successfully logged out!');
    } catch (error) {
      toast.error('Failed to log out: ' + error.message);
      throw error;
    }
  };

  const value = {
    currentUser,
    isAdmin,
    isLoading,
    db,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
